import { SVGProps } from 'react';

export const MediumPriority = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="8"
    viewBox="0 0 15 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5859 2.5H0.585938V0.5H14.5859V2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5859 7.5H0.585938V5.5H14.5859V7.5Z"
      fill="currentColor"
    />
  </svg>
);
